"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlippageIssuanceModule__factory = void 0;
var ethers_1 = require("ethers");
var _abi = [
    {
        inputs: [
            {
                internalType: "contract IController",
                name: "_controller",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_newFeeRecipient",
                type: "address",
            },
        ],
        name: "FeeRecipientUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_newIssueFee",
                type: "uint256",
            },
        ],
        name: "IssueFeeUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_newRedeemFee",
                type: "uint256",
            },
        ],
        name: "RedeemFeeUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_issuer",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_hookContract",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_quantity",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_managerFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_protocolFee",
                type: "uint256",
            },
        ],
        name: "SetTokenIssued",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_redeemer",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_quantity",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_managerFee",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_protocolFee",
                type: "uint256",
            },
        ],
        name: "SetTokenRedeemed",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_quantity",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "_isIssue",
                type: "bool",
            },
        ],
        name: "calculateTotalFees",
        outputs: [
            {
                internalType: "uint256",
                name: "totalQuantity",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "managerFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "protocolFee",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "controller",
        outputs: [
            {
                internalType: "contract IController",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
        ],
        name: "getModuleIssuanceHooks",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_quantity",
                type: "uint256",
            },
        ],
        name: "getRequiredComponentIssuanceUnits",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_quantity",
                type: "uint256",
            },
        ],
        name: "getRequiredComponentIssuanceUnitsOffChain",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_quantity",
                type: "uint256",
            },
        ],
        name: "getRequiredComponentRedemptionUnits",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_quantity",
                type: "uint256",
            },
        ],
        name: "getRequiredComponentRedemptionUnitsOffChain",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_maxManagerFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_managerIssueFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_managerRedeemFee",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_feeRecipient",
                type: "address",
            },
            {
                internalType: "contract IManagerIssuanceHook",
                name: "_managerIssuanceHook",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_hook",
                type: "address",
            },
        ],
        name: "isModuleIssuanceHook",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "",
                type: "address",
            },
        ],
        name: "issuanceSettings",
        outputs: [
            {
                internalType: "uint256",
                name: "maxManagerFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "managerIssueFee",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "managerRedeemFee",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "feeRecipient",
                type: "address",
            },
            {
                internalType: "contract IManagerIssuanceHook",
                name: "managerIssuanceHook",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_quantity",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
        ],
        name: "issue",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_setQuantity",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "_checkedComponents",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "_maxTokenAmountsIn",
                type: "uint256[]",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
        ],
        name: "issueWithSlippage",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_quantity",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
        ],
        name: "redeem",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_setQuantity",
                type: "uint256",
            },
            {
                internalType: "address[]",
                name: "_checkedComponents",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "_minTokenAmountsOut",
                type: "uint256[]",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
        ],
        name: "redeemWithSlippage",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
        ],
        name: "registerToIssuanceModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "removeModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
        ],
        name: "unregisterFromIssuanceModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_newFeeRecipient",
                type: "address",
            },
        ],
        name: "updateFeeRecipient",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_newIssueFee",
                type: "uint256",
            },
        ],
        name: "updateIssueFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISetToken",
                name: "_setToken",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_newRedeemFee",
                type: "uint256",
            },
        ],
        name: "updateRedeemFee",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "0x60806040523480156200001157600080fd5b50604051620046a4380380620046a483398101604081905262000034916200005e565b600080546001600160a01b0319166001600160a01b0392909216919091179055600180556200008e565b60006020828403121562000070578081fd5b81516001600160a01b038116811462000087578182fd5b9392505050565b614606806200009e6000396000f3fe608060405234801561001057600080fd5b506004361061012c5760003560e01c8063750ab7a8116100ad578063cb38b22311610071578063cb38b22314610286578063cd3c753914610299578063d9b1b6e0146102bd578063e0799620146102d0578063f77c4791146102e35761012c565b8063750ab7a8146102235780637cbe104014610236578063847ef08d146102495780638dda403714610251578063bf9fe138146102735761012c565b8063607ad89f116100f4578063607ad89f146101b757806363082446146101ca5780636b8e53b6146101ea5780636d78f47a146101fd5780636dd86aa9146102105761012c565b806308bc0e1114610131578063131e26b91461015a57806357aa792e1461017c5780635c833bfd1461018f5780635d98c373146101a4575b600080fd5b61014461013f36600461376b565b6102f8565b6040516101519190613b68565b60405180910390f35b61016d6101683660046137bf565b610372565b60405161015193929190613b7b565b61016d61018a3660046137bf565b6103a3565b6101a261019d3660046137ea565b6103ea565b005b6101a26101b2366004613787565b61056e565b61016d6101c53660046137bf565b61064e565b6101dd6101d8366004613787565b610660565b6040516101519190613bb2565b61016d6101f83660046137bf565b610694565b6101a261020b3660046137ea565b6106b7565b6101a261021e3660046137bf565b610845565b6101a261023136600461382b565b610911565b6101a261024436600461382b565b610a88565b6101a2610bf5565b61026461025f36600461391a565b610c78565b604051610151939291906144f7565b6101a2610281366004613950565b610e4e565b6101a26102943660046137bf565b610fd1565b6102ac6102a736600461376b565b61109c565b60405161015195949392919061450d565b6101a26102cb36600461376b565b6110d8565b6101a26102de36600461376b565b611190565b6102eb611246565b6040516101519190613aa7565b6001600160a01b03811660009081526002602090815260409182902060050180548351818402810184019094528084526060939283018282801561036557602002820191906000526020600020905b81546001600160a01b03168152600190910190602001808311610347575b505050505090505b919050565b6060806060600061038586866001610c78565b5050905061039586826001611255565b935093509350509250925092565b60608080600160006103b6878784610c78565b505090506060806103c88984866113d2565b915091506103d98984868585611755565b965096509650505050509250925092565b600260015414156104165760405162461bcd60e51b815260040161040d90614450565b60405180910390fd5b60026001558261042581611931565b600083116104455760405162461bcd60e51b815260040161040d90613da8565b61044f8484611959565b604051632770a7eb60e21b81526001600160a01b03851690639dc29fac9061047d9033908790600401613abb565b600060405180830381600087803b15801561049757600080fd5b505af11580156104ab573d6000803e3d6000fd5b5050505060008060006104c087876000610c78565b92509250925060608060606104d78a876000611255565b9250925092506104eb8a8760008685611a60565b6104fa8a878a60008787611b06565b6105058a8686611bad565b876001600160a01b0316336001600160a01b03168b6001600160a01b03167f54f4ed50e49638053e1655b45ee7ece434edd150e6771ac0aaedb8355be13a338c8989604051610556939291906144f7565b60405180910390a45050600180555050505050505050565b8161057881611d18565b6001600160a01b03821661059e5760405162461bcd60e51b815260040161040d906141c4565b6001600160a01b03808416600090815260026020526040902060030154838216911614156105de5760405162461bcd60e51b815260040161040d9061418d565b6001600160a01b038381166000818152600260205260409081902060030180546001600160a01b0319169386169390931790925590517faaebcf1bfa00580e41d966056b48521fa9f202645c86d4ddf28113e617c1b1d390610641908590613aa7565b60405180910390a2505050565b606080806000806103b6878783610c78565b6001600160a01b038083166000908152600260209081526040808320938516835260069093019052205460ff165b92915050565b606080606060006106a786866000610c78565b5050905061039586826000611255565b600260015414156106da5760405162461bcd60e51b815260040161040d90614450565b6002600155826106e981611931565b600083116107095760405162461bcd60e51b815260040161040d90613ebb565b600061071785853386611d3e565b90506107238585611ddf565b600080600061073488886001610c78565b925092509250606080606061074b8b876001611255565b9250925092506107608b878b60018787611b06565b61076e8b8760018685611a60565b6107798b8686611bad565b6040516340c10f1960e01b81526001600160a01b038c16906340c10f19906107a7908c908e90600401613abb565b600060405180830381600087803b1580156107c157600080fd5b505af11580156107d5573d6000803e3d6000fd5b50505050886001600160a01b0316336001600160a01b03168c6001600160a01b03167f1abc43bc3dd8b6c8bb9bcf1a14a84f83981bf5335700ef07758efefcb03a8c758a8e8a8a60405161082c9493929190613b42565b60405180910390a4505060018055505050505050505050565b8161084f81611d18565b6001600160a01b0383166000908152600260205260409020548211156108875760405162461bcd60e51b815260040161040d90613c54565b6001600160a01b038316600090815260026020819052604090912001548214156108c35760405162461bcd60e51b815260040161040d90613d00565b6001600160a01b03831660008181526002602081905260409182902001849055517f676eda176d6aa20e9aa09b9ee131487c90646cd2b951176f75bd6fccdc026177906106419085906144ee565b600260015414156109345760405162461bcd60e51b815260040161040d90614450565b60026001558461094381611931565b61094e858585611ee0565b6109588686611959565b604051632770a7eb60e21b81526001600160a01b03871690639dc29fac906109869033908990600401613abb565b600060405180830381600087803b1580156109a057600080fd5b505af11580156109b4573d6000803e3d6000fd5b50505050600080905060008060006109cd8a8a86610c78565b92509250925060608060606109e38d8789611255565b9250925092506109f68b8b85858b611f4e565b610a038d87898685611a60565b610a118d878b8a8787611b06565b610a1c8d8686611bad565b886001600160a01b0316336001600160a01b03168e6001600160a01b03167f54f4ed50e49638053e1655b45ee7ece434edd150e6771ac0aaedb8355be13a338f8989604051610a6d939291906144f7565b60405180910390a45050600180555050505050505050505050565b60026001541415610aab5760405162461bcd60e51b815260040161040d90614450565b600260015584610aba81611931565b610ac5858585611ee0565b6000610ad387873386611d3e565b9050610adf8787611ddf565b600160008080610af08b8b86610c78565b9250925092506060806060610b068e8789611255565b925092509250610b198c8c85858b611f4e565b610b278e878c8a8787611b06565b610b348e87898685611a60565b610b3f8e8686611bad565b50506040516340c10f1960e01b81526001600160a01b038d1691506340c10f1990610b70908a908e90600401613abb565b600060405180830381600087803b158015610b8a57600080fd5b505af1158015610b9e573d6000803e3d6000fd5b50505050866001600160a01b0316336001600160a01b03168c6001600160a01b03167f1abc43bc3dd8b6c8bb9bcf1a14a84f83981bf5335700ef07758efefcb03a8c75888e878760405161082c9493929190613b42565b3360009081526002602052604090206005015415610c255760405162461bcd60e51b815260040161040d9061440d565b3360009081526002602081905260408220828155600181018390559081018290556003810180546001600160a01b0319908116909155600482018054909116905590610c7460058301826133ce565b5050565b6000806000610c856133ec565b6001600160a01b03808816600090815260026020818152604092839020835160c0810185528154815260018201548184015292810154838501526003810154851660608401526004810154909416608083015260058401805484518184028101840190955280855292949360a08601939092830182828015610d3057602002820191906000526020600020905b81546001600160a01b03168152600190910190602001808311610d12575b5050509190925250506000805460405163792aa04f60e01b815293945090926001600160a01b03909116915063792aa04f90610d729030908590600401613abb565b60206040518083038186803b158015610d8a57600080fd5b505afa158015610d9e573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610dc291906139d5565b9050600086610dd5578260400151610ddb565b82602001515b90506000610def828a63ffffffff61204516565b9050610e01818463ffffffff61204516565b9450610e13818663ffffffff61207616565b955087610e2f57610e2a898263ffffffff61207616565b610e3f565b610e3f898263ffffffff6120b816565b96505050505093509350939050565b8533610e5a82826120dd565b87610e6481612103565b87871115610e845760405162461bcd60e51b815260040161040d90614114565b87861115610ea45760405162461bcd60e51b815260040161040d90614487565b6040805160c08101825289815260208082018a90528183018990526001600160a01b0388811660608401528716608083015282516000808252918101909352909160a08301915090526001600160a01b03808b1660009081526002602081815260409283902085518155858201516001820155928501519183019190915560608401516003830180549185166001600160a01b031992831617905560808501516004840180549190951691161790925560a083015180519192610f6f92600585019290910190613434565b50905050886001600160a01b0316630ffe0f1e6040518163ffffffff1660e01b8152600401600060405180830381600087803b158015610fae57600080fd5b505af1158015610fc2573d6000803e3d6000fd5b50505050505050505050505050565b81610fdb81611d18565b6001600160a01b0383166000908152600260205260409020548211156110135760405162461bcd60e51b815260040161040d90613e4d565b6001600160a01b03831660009081526002602052604090206001015482141561104e5760405162461bcd60e51b815260040161040d9061409e565b6001600160a01b03831660008181526002602052604090819020600101849055517fd1de57b1db6a29967f337d6f744b7811624dabf2be924c65708336a81678d077906106419085906144ee565b60026020819052600091825260409091208054600182015492820154600383015460049093015491939290916001600160a01b03918216911685565b806110e2816121c4565b816110ec81611931565b6001600160a01b038316600090815260026020908152604080832033845260060190915290205460ff16156111335760405162461bcd60e51b815260040161040d90614242565b50506001600160a01b03166000908152600260209081526040808320600581018054600181810183559186528486200180546001600160a01b0319163390811790915585526006909101909252909120805460ff19169091179055565b8061119a816121c4565b816111a481611931565b6001600160a01b038316600090815260026020908152604080832033845260060190915290205460ff166111ea5760405162461bcd60e51b815260040161040d90613d78565b6001600160a01b0383166000908152600260205260409020611215906005013363ffffffff61230616565b50506001600160a01b031660009081526002602090815260408083203384526006019091529020805460ff19169055565b6000546001600160a01b031681565b60608060608060608061126789612432565b825192955090935091506060816001600160401b038111801561128957600080fd5b506040519080825280602002602001820160405280156112b3578160200160208202803683370190505b5090506060826001600160401b03811180156112ce57600080fd5b506040519080825280602002602001820160405280156112f8578160200160208202803683370190505b50905060005b86518110156113be578a611337576113328c87838151811061131c57fe5b602002602001015161204590919063ffffffff16565b61135d565b61135d8c87838151811061134757fe5b60200260200101516127bc90919063ffffffff16565b83828151811061136957fe5b6020026020010181815250508a61138f5761138a8c86838151811061134757fe5b61139f565b61139f8c86838151811061131c57fe5b8282815181106113ab57fe5b60209081029190910101526001016112fe565b50949b909a50939850929650505050505050565b6060806000856001600160a01b03166399d50d5d6040518163ffffffff1660e01b815260040160006040518083038186803b15801561141057600080fd5b505afa158015611424573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261144c91908101906135c9565b5190506060816001600160401b038111801561146757600080fd5b50604051908082528060200260200182016040528015611491578160200160208202803683370190505b5090506060826001600160401b03811180156114ac57600080fd5b506040519080825280602002602001820160405280156114d6578160200160208202803683370190505b506001600160a01b0389166000908152600260209081526040918290206005018054835181840281018401909452808452939450606093909183018282801561154857602002820191906000526020600020905b81546001600160a01b0316815260019091019060200180831161152a575b50939450600093505050505b815181101561174657606080896116015783838151811061157157fe5b60200260200101516001600160a01b031663d23cd5648d8d6040518363ffffffff1660e01b81526004016115a6929190613abb565b600060405180830381600087803b1580156115c057600080fd5b505af11580156115d4573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526115fc9190810190613664565b611698565b83838151811061160d57fe5b60200260200101516001600160a01b031663fc62d9fe8d8d6040518363ffffffff1660e01b8152600401611642929190613abb565b600060405180830381600087803b15801561165c57600080fd5b505af1158015611670573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526116989190810190613664565b909250905060005b8781101561173b576116e18382815181106116b757fe5b60200260200101518883815181106116cb57fe5b602002602001015161281390919063ffffffff16565b8782815181106116ed57fe5b60200260200101818152505061171c82828151811061170857fe5b60200260200101518783815181106116cb57fe5b86828151811061172857fe5b60209081029190910101526001016116a0565b505050600101611554565b50919890975095505050505050565b6060806060806060806117678b612432565b925092509250606083516001600160401b038111801561178657600080fd5b506040519080825280602002602001820160405280156117b0578160200160208202803683370190505b509050606084516001600160401b03811180156117cc57600080fd5b506040519080825280602002602001820160405280156117f6578160200160208202803683370190505b50905060005b855181101561191c57600061184e6118498d848151811061181957fe5b602002602001015161183d89868151811061183057fe5b6020026020010151612859565b9063ffffffff61281316565b612882565b90508c61186a57611865818f63ffffffff61204516565b61187a565b61187a818f63ffffffff6127bc16565b84838151811061188657fe5b60200260200101818152505060006118c96118498d85815181106118a657fe5b60200260200101516118bd89878151811061183057fe5b9063ffffffff6128a416565b90508d6118e8576118e38f826127bc90919063ffffffff16565b6118fb565b6118fb8f8261204590919063ffffffff16565b84848151811061190757fe5b602090810291909101015250506001016117fc565b50939c909b5092995091975050505050505050565b61193a816128ea565b6119565760405162461bcd60e51b815260040161040d90613d30565b50565b6001600160a01b0382166000908152600260209081526040918290206005018054835181840281018401909452808452606093928301828280156119c657602002820191906000526020600020905b81546001600160a01b031681526001909101906020018083116119a8575b50939450600093505050505b8151811015611a5a578181815181106119e757fe5b60200260200101516001600160a01b0316633fe6106b85856040518363ffffffff1660e01b8152600401611a1c929190613abb565b600060405180830381600087803b158015611a3657600080fd5b505af1158015611a4a573d6000803e3d6000fd5b5050600190920191506119d29050565b50505050565b60005b8251811015611afe576000838281518110611a7a57fe5b602002602001015190506000838381518110611a9257fe5b602002602001015190506000811115611af4578515611ada57611aba888884600160006129ee565b611ad56001600160a01b03891683338463ffffffff612ba816565b611af4565b611ae682338a84612cea565b611af48888846000806129ee565b5050600101611a63565b505050505050565b60005b8251811015611ba4576000838281518110611b2057fe5b602002602001015190506000838381518110611b3857fe5b602002602001015190506000811115611b9a578515611b7057611b5d82338b84612cea565b611b6b8989846001806129ee565b611b9a565b611b7f898984600060016129ee565b611b9a6001600160a01b038a1683898463ffffffff612ba816565b5050600101611b09565b50505050505050565b8115611d13576001600160a01b03808416600081815260026020526040908190206003015490516340c10f1960e01b815291926340c10f1992611bf892909116908690600401613abb565b600060405180830381600087803b158015611c1257600080fd5b505af1158015611c26573d6000803e3d6000fd5b505050506000811115611d1357826001600160a01b03166340c10f196000809054906101000a90046001600160a01b03166001600160a01b031663469048406040518163ffffffff1660e01b815260040160206040518083038186803b158015611c8f57600080fd5b505afa158015611ca3573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611cc791906135ad565b836040518363ffffffff1660e01b8152600401611ce5929190613abb565b600060405180830381600087803b158015611cff57600080fd5b505af1158015611ba4573d6000803e3d6000fd5b505050565b611d228133612cf6565b6119315760405162461bcd60e51b815260040161040d90614348565b6001600160a01b038085166000908152600260205260408120600401549091168015611dd15760405163a045808360e01b81526001600160a01b0382169063a045808390611d96908990899089908990600401613bbd565b600060405180830381600087803b158015611db057600080fd5b505af1158015611dc4573d6000803e3d6000fd5b5050505080915050611dd7565b60009150505b949350505050565b6001600160a01b038216600090815260026020908152604091829020600501805483518184028101840190945280845260609392830182828015611e4c57602002820191906000526020600020905b81546001600160a01b03168152600190910190602001808311611e2e575b50939450600093505050505b8151811015611a5a57818181518110611e6d57fe5b60200260200101516001600160a01b031663c153dd0785856040518363ffffffff1660e01b8152600401611ea2929190613abb565b600060405180830381600087803b158015611ebc57600080fd5b505af1158015611ed0573d6000803e3d6000fd5b505060019092019150611e589050565b60008311611f005760405162461bcd60e51b815260040161040d90613e84565b815181518114611f225760405162461bcd60e51b815260040161040d90613c8b565b8015611a5a57611f3183612d84565b15611a5a5760405162461bcd60e51b815260040161040d90613f33565b60005b8551811015611afe57600080611f83888481518110611f6c57fe5b602002602001015187612e3390919063ffffffff16565b9150915080611fa45760405162461bcd60e51b815260040161040d90613f6a565b8315611ff557848281518110611fb657fe5b6020026020010151878481518110611fca57fe5b60200260200101511015611ff05760405162461bcd60e51b815260040161040d90613fac565b61203b565b84828151811061200157fe5b602002602001015187848151811061201557fe5b6020026020010151111561203b5760405162461bcd60e51b815260040161040d90613cba565b5050600101611f51565b600061206f670de0b6b3a7640000612063858563ffffffff612e9916565b9063ffffffff612ed316565b9392505050565b600061206f83836040518060400160405280601e81526020017f536166654d6174683a207375627472616374696f6e206f766572666c6f770000815250612f15565b60008282018381101561206f5760405162461bcd60e51b815260040161040d90613ddf565b6120e78282612cf6565b610c745760405162461bcd60e51b815260040161040d90614348565b600054604051631d3af8fb60e21b81526001600160a01b03909116906374ebe3ec90612133908490600401613aa7565b60206040518083038186803b15801561214b57600080fd5b505afa15801561215f573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061218391906136c4565b61219f5760405162461bcd60e51b815260040161040d90614305565b6121a881612f41565b6119565760405162461bcd60e51b815260040161040d90613e16565b6002604051631ade272960e11b81526001600160a01b038316906335bc4e52906121f2903390600401613aa7565b60206040518083038186803b15801561220a57600080fd5b505afa15801561221e573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061224291906139b6565b600281111561224d57fe5b1461226a5760405162461bcd60e51b815260040161040d90614026565b6000546040516342f6e38960e01b81526001600160a01b03909116906342f6e3899061229a903390600401613aa7565b60206040518083038186803b1580156122b257600080fd5b505afa1580156122c6573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906122ea91906136c4565b6119565760405162461bcd60e51b815260040161040d906142c1565b60008061236c8480548060200260200160405190810160405280929190818152602001828054801561236157602002820191906000526020600020905b81546001600160a01b03168152600190910190602001808311612343575b505050505084612e33565b915091508061238d5760405162461bcd60e51b815260040161040d90613c25565b8354600019018281146123ff578481815481106123a657fe5b9060005260206000200160009054906101000a90046001600160a01b03168584815481106123d057fe5b9060005260206000200160006101000a8154816001600160a01b0302191690836001600160a01b031602179055505b8480548061240957fe5b600082815260209020810160001990810180546001600160a01b03191690550190555050505050565b606080606080846001600160a01b03166399d50d5d6040518163ffffffff1660e01b815260040160006040518083038186803b15801561247157600080fd5b505afa158015612485573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526124ad91908101906135c9565b80519091506060816001600160401b03811180156124ca57600080fd5b506040519080825280602002602001820160405280156124f4578160200160208202803683370190505b5090506060826001600160401b038111801561250f57600080fd5b50604051908082528060200260200182016040528015612539578160200160208202803683370190505b50905060005b84518110156127ac57600085828151811061255657fe5b6020026020010151905060008a6001600160a01b03166366cb8d2f836040518263ffffffff1660e01b815260040161258e9190613aa7565b60206040518083038186803b1580156125a657600080fd5b505afa1580156125ba573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906125de91906139d5565b60405163a7bdad0360e01b81529091506000906060906001600160a01b038e169063a7bdad0390612613908790600401613aa7565b60006040518083038186803b15801561262b57600080fd5b505afa15801561263f573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261266791908101906135c9565b8051909150156127505760005b815181101561274e5760008e6001600160a01b03166322ebeba48785858151811061269b57fe5b60200260200101516040518363ffffffff1660e01b81526004016126c0929190613ad4565b60206040518083038186803b1580156126d857600080fd5b505afa1580156126ec573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061271091906139d5565b905060008113156127325761272b858263ffffffff61281316565b9450612745565b612742848263ffffffff61281316565b93505b50600101612674565b505b61275983612882565b87868151811061276557fe5b60209081029190910101526127856118498360001963ffffffff612f7016565b86868151811061279157fe5b602090810291909101015250506001909201915061253f9050565b5092979096509194509092505050565b60008215806127c9575081155b156127d65750600061068e565b61206f6001612807670de0b6b3a7640000612063836127fb898963ffffffff612e9916565b9063ffffffff61207616565b9063ffffffff6120b816565b60008282018183128015906128285750838112155b8061283d575060008312801561283d57508381125b61206f5760405162461bcd60e51b815260040161040d90613ef2565b6000600160ff1b821061287e5760405162461bcd60e51b815260040161040d90614279565b5090565b60008082121561287e5760405162461bcd60e51b815260040161040d90613ff1565b60008183038183128015906128b95750838113155b806128ce57506000831280156128ce57508381135b61206f5760405162461bcd60e51b815260040161040d9061437f565b60008054604051631d3af8fb60e21b81526001600160a01b03909116906374ebe3ec9061291b908590600401613aa7565b60206040518083038186803b15801561293357600080fd5b505afa158015612947573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061296b91906136c4565b801561068e57506040516335fc6c9f60e21b81526001600160a01b0383169063d7f1b27c9061299e903090600401613aa7565b60206040518083038186803b1580156129b657600080fd5b505afa1580156129ca573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061068e91906136c4565b60405163a7bdad0360e01b81526060906001600160a01b0387169063a7bdad0390612a1d908790600401613aa7565b60006040518083038186803b158015612a3557600080fd5b505afa158015612a49573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052612a7191908101906135c9565b80519091508315612b105760005b81811015612b0a57828181518110612a9357fe5b60200260200101516001600160a01b0316630fb96b21898989886040518563ffffffff1660e01b8152600401612acc9493929190613be8565b600060405180830381600087803b158015612ae657600080fd5b505af1158015612afa573d6000803e3d6000fd5b505060019092019150612a7f9050565b50611ba4565b60005b81811015612b9e57828181518110612b2757fe5b60200260200101516001600160a01b031663c137f4d7898989886040518563ffffffff1660e01b8152600401612b609493929190613be8565b600060405180830381600087803b158015612b7a57600080fd5b505af1158015612b8e573d6000803e3d6000fd5b505060019092019150612b139050565b5050505050505050565b8015611a5a576040516370a0823160e01b81526000906001600160a01b038516906370a0823190612bdd908890600401613aa7565b60206040518083038186803b158015612bf557600080fd5b505afa158015612c09573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612c2d91906139d5565b9050612c3b85858585612fdb565b6040516370a0823160e01b81526000906001600160a01b038616906370a0823190612c6a908990600401613aa7565b60206040518083038186803b158015612c8257600080fd5b505afa158015612c96573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612cba91906139d5565b9050612ccc828463ffffffff61207616565b8114611afe5760405162461bcd60e51b815260040161040d90614156565b611a5a848484846130a8565b6000816001600160a01b0316836001600160a01b031663481c6a756040518163ffffffff1660e01b815260040160206040518083038186803b158015612d3b57600080fd5b505afa158015612d4f573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612d7391906135ad565b6001600160a01b0316149392505050565b600080825111612da65760405162461bcd60e51b815260040161040d906144ca565b60005b6001835103811015612e2a576000838281518110612dc357fe5b6020026020010151905060008260010190505b8451811015612e2057848181518110612deb57fe5b60200260200101516001600160a01b0316826001600160a01b03161415612e18576001935050505061036d565b600101612dd6565b5050600101612da9565b50600092915050565b81516000908190815b81811015612e8657846001600160a01b0316868281518110612e5a57fe5b60200260200101516001600160a01b03161415612e7e57925060019150612e929050565b600101612e3c565b50600019600092509250505b9250929050565b600082612ea85750600061068e565b82820282848281612eb557fe5b041461206f5760405162461bcd60e51b815260040161040d9061405d565b600061206f83836040518060400160405280601a81526020017f536166654d6174683a206469766973696f6e206279207a65726f0000000000008152506131cc565b60008184841115612f395760405162461bcd60e51b815260040161040d9190613c12565b505050900390565b6040516353bae5f760e01b81526000906001600160a01b038316906353bae5f79061299e903090600401613aa7565b600082612f7f5750600061068e565b82600019148015612f935750600160ff1b82145b15612fb05760405162461bcd60e51b815260040161040d906140cd565b82820282848281612fbd57fe5b051461206f5760405162461bcd60e51b815260040161040d906140cd565b8015611a5a5760608282604051602401612ff6929190613abb565b60408051601f198184030181529181526020820180516001600160e01b031663a9059cbb60e01b179052516347b7819960e11b81529091506001600160a01b03861690638f6f0332906130529087906000908690600401613b12565b600060405180830381600087803b15801561306c57600080fd5b505af1158015613080573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052611afe91908101906136e0565b8015611a5a576040516370a0823160e01b81526000906001600160a01b038616906370a08231906130dd908690600401613aa7565b60206040518083038186803b1580156130f557600080fd5b505afa158015613109573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061312d91906139d5565b905061313b85858585613203565b6040516370a0823160e01b81526000906001600160a01b038716906370a082319061316a908790600401613aa7565b60206040518083038186803b15801561318257600080fd5b505afa158015613196573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906131ba91906139d5565b9050612ccc828463ffffffff6120b816565b600081836131ed5760405162461bcd60e51b815260040161040d9190613c12565b5060008385816131f957fe5b0495945050505050565b611a5a846323b872dd60e01b85858560405160240161322493929190613aee565b60408051601f198184030181529190526020810180516001600160e01b03166001600160e01b03199093169290921790915260606132ab826040518060400160405280602081526020017f5361666545524332303a206c6f772d6c6576656c2063616c6c206661696c6564815250856001600160a01b03166132e59092919063ffffffff16565b805190915015611d1357808060200190518101906132c991906136c4565b611d135760405162461bcd60e51b815260040161040d906143c3565b6060611dd78484600085856132f98561338f565b6133155760405162461bcd60e51b815260040161040d9061420b565b60006060866001600160a01b031685876040516133329190613a8b565b60006040518083038185875af1925050503d806000811461336f576040519150601f19603f3d011682016040523d82523d6000602084013e613374565b606091505b5091509150613384828286613395565b979650505050505050565b3b151590565b606083156133a457508161206f565b8251156133b45782518084602001fd5b8160405162461bcd60e51b815260040161040d9190613c12565b50805460008255906000526020600020908101906119569190613495565b6040518060c0016040528060008152602001600081526020016000815260200160006001600160a01b0316815260200160006001600160a01b03168152602001606081525090565b828054828255906000526020600020908101928215613489579160200282015b8281111561348957825182546001600160a01b0319166001600160a01b03909116178255602090920191600190910190613454565b5061287e9291506134b2565b6134af91905b8082111561287e576000815560010161349b565b90565b6134af91905b8082111561287e5780546001600160a01b03191681556001016134b8565b803561068e816145ad565b600082601f8301126134f1578081fd5b81516135046134ff82614562565b61453c565b81815291506020808301908481018184028601820187101561352557600080fd5b60005b8481101561354457815184529282019290820190600101613528565b505050505092915050565b600082601f83011261355f578081fd5b813561356d6134ff82614562565b81815291506020808301908481018184028601820187101561358e57600080fd5b60005b8481101561354457813584529282019290820190600101613591565b6000602082840312156135be578081fd5b815161206f816145ad565b600060208083850312156135db578182fd5b82516001600160401b038111156135f0578283fd5b80840185601f820112613601578384fd5b805191506136116134ff83614562565b828152838101908285018585028401860189101561362d578687fd5b8693505b84841015613658578051613644816145ad565b835260019390930192918501918501613631565b50979650505050505050565b60008060408385031215613676578081fd5b82516001600160401b038082111561368c578283fd5b613698868387016134e1565b935060208501519150808211156136ad578283fd5b506136ba858286016134e1565b9150509250929050565b6000602082840312156136d5578081fd5b815161206f816145c2565b6000602082840312156136f1578081fd5b81516001600160401b0380821115613707578283fd5b81840185601f820112613718578384fd5b8051925081831115613728578384fd5b61373b601f8401601f191660200161453c565b9150828252856020848301011115613751578384fd5b613762836020840160208401614581565b50949350505050565b60006020828403121561377c578081fd5b813561206f816145ad565b60008060408385031215613799578182fd5b82356137a4816145ad565b915060208301356137b4816145ad565b809150509250929050565b600080604083850312156137d1578182fd5b82356137dc816145ad565b946020939093013593505050565b6000806000606084860312156137fe578081fd5b8335613809816145ad565b9250602084013591506040840135613820816145ad565b809150509250925092565b600080600080600060a08688031215613842578283fd5b853561384d816145ad565b9450602086810135945060408701356001600160401b0380821115613870578586fd5b8189018a601f820112613881578687fd5b803592506138916134ff84614562565b83815284810190828601868602840187018e10156138ad57898afd5b8993505b858410156138d85780356138c4816145ad565b8352600193909301929186019186016138b1565b509750505060608901359250808311156138f0578384fd5b50506138fe8882890161354f565b92505061390e87608088016134d6565b90509295509295909350565b60008060006060848603121561392e578081fd5b8335613939816145ad565b9250602084013591506040840135613820816145c2565b60008060008060008060c08789031215613968578384fd5b8635613973816145ad565b95506020870135945060408701359350606087013592506080870135613998816145ad565b915060a08701356139a8816145ad565b809150509295509295509295565b6000602082840312156139c7578081fd5b81516003811061206f578182fd5b6000602082840312156139e6578081fd5b5051919050565b6000815180845260208085019450808401835b83811015613a255781516001600160a01b031687529582019590820190600101613a00565b509495945050505050565b6000815180845260208085019450808401835b83811015613a2557815187529582019590820190600101613a43565b60008151808452613a77816020860160208601614581565b601f01601f19169290920160200192915050565b60008251613a9d818460208701614581565b9190910192915050565b6001600160a01b0391909116815260200190565b6001600160a01b03929092168252602082015260400190565b6001600160a01b0392831681529116602082015260400190565b6001600160a01b039384168152919092166020820152604081019190915260600190565b600060018060a01b038516825283602083015260606040830152613b396060830184613a5f565b95945050505050565b6001600160a01b0394909416845260208401929092526040830152606082015260800190565b60006020825261206f60208301846139ed565b600060608252613b8e60608301866139ed565b8281036020840152613ba08186613a30565b83810360408501526133848186613a30565b901515815260200190565b6001600160a01b03948516815260208101939093529083166040830152909116606082015260800190565b6001600160a01b039485168152602081019390935292166040820152901515606082015260800190565b60006020825261206f6020830184613a5f565b60208082526015908201527420b2323932b9b9903737ba1034b71030b93930bc9760591b604082015260600190565b6020808252601f908201527f52656465656d206665652063616e277420657863656564206d6178696d756d00604082015260600190565b602080825260159082015274082e4e4c2f240d8cadccee8d040dad2e6dac2e8c6d605b1b604082015260600190565b60208082526026908201527f546f6f2066657720746f6b656e732072657475726e656420666f72207265646560408201526536b83a34b7b760d11b606082015260800190565b60208082526016908201527514d85b59481c995919595b48199959481c185cdcd95960521b604082015260600190565b60208082526028908201527f4d75737420626520612076616c696420616e6420696e697469616c697a65642060408201526729b2ba2a37b5b2b760c11b606082015260800190565b60208082526016908201527526b7b23ab632903737ba103932b3b4b9ba32b932b21760511b604082015260600190565b6020808252601b908201527f52656465656d207175616e74697479206d757374206265203e20300000000000604082015260600190565b6020808252601b908201527f536166654d6174683a206164646974696f6e206f766572666c6f770000000000604082015260600190565b6020808252601e908201527f4d7573742062652070656e64696e6720696e697469616c697a6174696f6e0000604082015260600190565b6020808252601e908201527f4973737565206665652063616e277420657863656564206d6178696d756d0000604082015260600190565b6020808252601d908201527f536574546f6b656e207175616e74697479206d757374206265203e2030000000604082015260600190565b6020808252601a908201527f4973737565207175616e74697479206d757374206265203e2030000000000000604082015260600190565b60208082526021908201527f5369676e6564536166654d6174683a206164646974696f6e206f766572666c6f6040820152607760f81b606082015260800190565b6020808252601a908201527f43616e6e6f74206475706c696361746520616464726573736573000000000000604082015260600190565b60208082526022908201527f4c696d69742070617373656420666f7220696e76616c696420636f6d706f6e656040820152611b9d60f21b606082015260800190565b60208082526025908201527f546f6f206d616e7920746f6b656e7320726571756972656420666f722069737360408201526475616e636560d81b606082015260800190565b6020808252818101527f53616665436173743a2076616c7565206d75737420626520706f736974697665604082015260600190565b60208082526018908201527f4f6e6c7920746865206d6f64756c652063616e2063616c6c0000000000000000604082015260600190565b60208082526021908201527f536166654d6174683a206d756c7469706c69636174696f6e206f766572666c6f6040820152607760f81b606082015260800190565b60208082526015908201527414d85b59481a5cdcdd5948199959481c185cdcd959605a1b604082015260600190565b60208082526027908201527f5369676e6564536166654d6174683a206d756c7469706c69636174696f6e206f604082015266766572666c6f7760c81b606082015260800190565b60208082526022908201527f4973737565206665652063616e277420657863656564206d6178696d756d2066604082015261656560f01b606082015260800190565b6020808252601d908201527f496e76616c696420706f7374207472616e736665722062616c616e6365000000604082015260600190565b60208082526019908201527f53616d652066656520726563697069656e742070617373656400000000000000604082015260600190565b60208082526027908201527f46656520526563697069656e74206d757374206265206e6f6e2d7a65726f206160408201526632323932b9b99760c91b606082015260800190565b6020808252601d908201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e7472616374000000604082015260600190565b6020808252601a908201527f4d6f64756c6520616c726561647920726567697374657265642e000000000000604082015260600190565b60208082526028908201527f53616665436173743a2076616c756520646f65736e27742066697420696e2061604082015267371034b73a191a9b60c11b606082015260800190565b60208082526024908201527f4d6f64756c65206d75737420626520656e61626c6564206f6e20636f6e74726f604082015263363632b960e11b606082015260800190565b60208082526023908201527f4d75737420626520636f6e74726f6c6c65722d656e61626c656420536574546f60408201526235b2b760e91b606082015260800190565b6020808252601c908201527f4d7573742062652074686520536574546f6b656e206d616e6167657200000000604082015260600190565b60208082526024908201527f5369676e6564536166654d6174683a207375627472616374696f6e206f766572604082015263666c6f7760e01b606082015260800190565b6020808252602a908201527f5361666545524332303a204552433230206f7065726174696f6e20646964206e6040820152691bdd081cdd58d8d9595960b21b606082015260800190565b60208082526023908201527f52656769737465726564206d6f64756c6573206d7573742062652072656d6f7660408201526232b21760e91b606082015260800190565b6020808252601f908201527f5265656e7472616e637947756172643a207265656e7472616e742063616c6c00604082015260600190565b60208082526023908201527f52656465656d206665652063616e277420657863656564206d6178696d756d2060408201526266656560e81b606082015260800190565b6020808252600a90820152694120697320656d70747960b01b604082015260600190565b90815260200190565b9283526020830191909152604082015260600190565b948552602085019390935260408401919091526001600160a01b03908116606084015216608082015260a00190565b6040518181016001600160401b038111828210171561455a57600080fd5b604052919050565b60006001600160401b03821115614577578081fd5b5060209081020190565b60005b8381101561459c578181015183820152602001614584565b83811115611a5a5750506000910152565b6001600160a01b038116811461195657600080fd5b801515811461195657600080fdfea26469706673582212208c15f65574e74c7aa42401a7a2be20cf6630a2975201db1b4a53b96a122d44fe64736f6c634300060a0033";
var SlippageIssuanceModule__factory = /** @class */ (function (_super) {
    __extends(SlippageIssuanceModule__factory, _super);
    function SlippageIssuanceModule__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    SlippageIssuanceModule__factory.prototype.deploy = function (_controller, overrides) {
        return _super.prototype.deploy.call(this, _controller, overrides || {});
    };
    SlippageIssuanceModule__factory.prototype.getDeployTransaction = function (_controller, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _controller, overrides || {});
    };
    SlippageIssuanceModule__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    SlippageIssuanceModule__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    SlippageIssuanceModule__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    SlippageIssuanceModule__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    SlippageIssuanceModule__factory.bytecode = _bytecode;
    SlippageIssuanceModule__factory.abi = _abi;
    return SlippageIssuanceModule__factory;
}(ethers_1.ContractFactory));
exports.SlippageIssuanceModule__factory = SlippageIssuanceModule__factory;
//# sourceMappingURL=SlippageIssuanceModule__factory.js.map